<template>
 <div class="dateView-Container">

   <div id="sel_card_wrap">
     <el-card id="pdm-card" :body-style="{padding:'5px'}" :class="{'card-sel':isPDM}" >
       <div class="daop_row" @click="selectPDM">
         <div class="sel-icon" :class="{'sel':isPDM}">
         </div>
         <div class="daop_name">
           <p>{{$t('daop_uploaded_data')}}</p>
         </div>
         <div class="daop_sep">
         </div>
         <div class="daop_text">
           <p>{{$t('daop_uploaded_data_text')}}</p>
         </div>
         <div class="daop_app_icon easytouch">
         </div>
         <div class="daop_app_icon easyview_ipad">
         </div>
         <div style="clear: both"></div>
       </div>
     </el-card>

     <el-card id="realtime-card" :body-style="{padding:'5px'}" :class="{'card-sel':isRealtime}" >
       <div class="daop_row" @click="selectRealtime">
         <div class="sel-icon" :class="{'sel':isRealtime}">
         </div>
         <div class="daop_name">
           <p>{{$t('daop_realtime_data')}}</p>
         </div>
         <div class="daop_sep">
         </div>
         <div class="daop_text">
           <p>{{$t('t1104_The_data_is_from')}}</p>
         </div>
         <div class="daop_app_icon easysense">
         </div>
         <div class="daop_app_icon easypatch">
         </div>
         <div style="clear: both"></div>
       </div>
     </el-card>

     <div class="upload_history">
       <p><a href="javascript:void(0);" @click="goToUploadHistory()">{{$t('t1105_Upload_History')}}</a></p>
     </div>

     <!--
     <el-card id="pdm-card" :class="{'card-sel':isPDM}">
       <div @click="selectPDM">
         <div class="sel-icon" :class="{'sel':isPDM}">
         </div>
         <div class="pdm-icon">
         </div>
         <div class="pdm-text"><p>{{$t('daop_A6_system')}}</p></div>
         <div class="plus-icon"></div>
         <div class="pdm-app-icon"></div>
         <div class="pdm-text"><p>{{$t('daop_easytouch_easyview')}}</p></div>
       </div>

     </el-card>

     <el-card id="realtime-card" :class="{'card-sel':isRealtime}">
       <div @click="selectRealtime">
         <div class="sel-icon" :class="{'sel':isRealtime}">
         </div>
         <div class="pdm-icon">
           <div>&nbsp;</div>
           <div class="icon">

           </div>
         </div>
         <div class="pdm-text"><p>{{$t('daop_TY012_TY015')}}</p></div>
         <div class="plus-icon"></div>
         <div class="realtime-app-icon"></div>
         <div class="pdm-text"><p>{{$t('daop_easysense')}}</p></div>
       </div>
     </el-card> -->

   </div>

   <div class="central-btn-container" v-show="isP">
     <button class="data-delete" :class="{}" @click="deleteData">
       <span>{{$t('t1105_Delete_Data')}}</span>
     </button>
   </div>

 </div>
</template>

<script>
  import auth from '../../auth/auth'
  export default{
    data(){
      return{
        Sessions:'',overLapp1:[],overLapp2:[],isLapp1:false,isLapp2:false,LapList1:'',LapList2:'',
        isA:'',isB:'',
        isC:false,
        isP:'',
        isK:false,flag:0,flag1:0, uid:0,cgms:[],pump:[],set:[],isZh:false,
        isPDM:false, isRealtime:false,

      }
    },
    created(){
      if(sessionStorage.getItem('userType')!=='P'){
        this.uid = parseInt(sessionStorage.getItem('patientId'));
      }else{
        this.uid = parseInt(sessionStorage.getItem('uid'));
      }
      auth.getSet(this,this.uid);
      //auth.getSessions(this,this.uid);
    },
    mounted:function () {
     /* if(sessionStorage.getItem('userType')!=='P'){
        this.uid = parseInt(sessionStorage.getItem('patientId'));
      }else{
        this.uid = parseInt(sessionStorage.getItem('uid'));
      }
      auth.getSet(this,this.uid);*/
      if(!sessionStorage.getItem('dateViewA')){
         // this.isA = true;
         // this.isB = false;
      }
      else{
        this.isA = sessionStorage.getItem('dateViewA')==='1'? true:false;
        this.isB = sessionStorage.getItem('dateViewB')==='1'? true:false;
      }
     // auth.getSessions(this,this.uid);
      let lang = sessionStorage.getItem('language');
      this.isZh = (lang==='zh')?true:false;
      this.isP=(sessionStorage.getItem('userType')==='P');
    },
    methods:{
      selectPDM(){
        if (this.isPDM)
          return;

        this.isPDM=true;
        this.isRealtime=false;
        //console.log("selectPDM:");
        this.saveOption();
      },
      selectRealtime(){
        if (this.isRealtime)
          return;

        this.isPDM=false;
        this.isRealtime=true;
        this.saveOption();
      },
      changeType1(){
        /*this.isA = true;
        this.isB = false;
        this.set1();
        this.initSet();
        sessionStorage.setItem('dateViewA',1);
        sessionStorage.setItem('dateViewB',0);*/
      },
      changeType2(){
        this.isB = true;
        this.isA = false;
      },
      deleteData() {
        let tip = this.$t('deleteData');
        let tip1 = this.$t('confirm');
        let tip2 = this.$t('Delete');
        let tip3 = this.$t('Cancel');
        this.$confirm(tip, tip1, {
          confirmButtonText: tip2,
          cancelButtonText: tip3,
          type: 'warning'
        }).then(() => {
          //auth.deleteEvents(this,this.uid,this.eids);
          auth.deleteData(this);
        },function () {

        });
      },
      choose(){
        this.isC = !this.isC;
        const table1  = document.getElementById('table1');
        const labels = table1.getElementsByTagName('label');
        for(let i=0;i<labels.length;i++){
            if(this.flag===0){
              labels[i].className = 'checked';
            }else{
              labels[i].className = '';
            }
        }
        //判断下一次点击是全选还是全不选
        if(labels[0].className==='checked'){this.flag = 1;}
        else{ this.flag = 0;}
        this.checkOverLapp();
      },
      select(flag,e){
        let index = e.target.parentNode.id;
        let id =0;
        if(e.target.className===''){
          e.target.className = 'checked';
        }else{
          e.target.className = '';
        }
        this.checkOverLapp();
      },
      choose2(){
        this.isK = !this.isK;
        const table2  = document.getElementById('table2');
        const labels = table2.getElementsByTagName('label');
        for(let i=0;i<labels.length;i++){
          if(this.flag1===0){
            labels[i].className = 'checked';
          }else{
            labels[i].className = '';
          }
        }
        if(labels[0].className==='checked'){ this.flag1 = 1;}
        else{ this.flag1 = 0;}
        //console.log(labels.length,this.pump);
        this.checkOverLapp();
      },
      goToUploadHistory(){
        this.$router.push('/dateView');
      },
      set1(){
         let data = {
           option:'daopapp',
           cgms:[],
           pump:[],
         } ;
         auth.setData(this,this.uid,{data:data});
      },
      set2(){
        //this.checkData();
        if(this.isLapp1||this.isLapp2){
          let tip = this.$t('Time overlapped');
          this.$message.error(tip);
        }else{
          let data = {
            option:'daoppdm',
            cgms:this.cgms,
            pump:this.pump,
          } ;
          if(this.cgms.length===0&&this.pump.length===0){
            let tip =this.$t('selectData');
            this.$message.error(tip);
          }else{
            auth.setData(this,this.uid,{data:data});
            sessionStorage.setItem('dateViewA',0);
            sessionStorage.setItem('dateViewB',1);
          }
        }
      },
      saveOption(){
        let data = {
          option:'daoppdm',
          //cgms:this.cgms,
          //pump:this.pump,
          cgms:[],
          pump:[],
        } ;
        if (this.isPDM && !this.isRealtime) {
          data.option='daoppdm';
        } else if (!this.isPDM && this.isRealtime) {
          data.option='daopapp';
        } else {
          return;
        }
        auth.setData(this,this.uid,{data:data});
      },
      checkData(){
        this.cgms =[];
        this.pump = [];
        const table1  = document.getElementById('table1');
        const labels1 = table1.getElementsByTagName('label');
        for(let i=0;i<labels1.length;i++){
            if(labels1[i].className=== 'checked'){
              let id = this.Sessions[0][i][2];
              this.cgms.push(id);
            }
        }
        const table2  = document.getElementById('table2');
        const labels2= table2.getElementsByTagName('label');
        for(let i=0;i<labels2.length;i++){
            if(labels2[i].className ==='checked'){
              let id = this.Sessions[1][i][2];
              this.pump.push(id);
            }
        }

        if(this.cgms.length===this.Sessions[0].length){
          this.isC = true;
          this.flag = 1;
        }else{
          this.isC = false;
          this.flag = 0;
        }
        if(this.pump.length===this.Sessions[1].length){
          this.isK = true;
          this.flag1 = 1;
        }else{
          this.isK = false;
          this.flag1 = 0;
        }
      },

      forMatter(val){
          let that =this;
          val.map(function (e,i) {
            let t1 = e[1].split(' ');
            let t11 = t1[0].split('-');
            e[1] = (that.isZh)? Date.parse(t11[0]+'/'+t11[1]+'/'+t11[2]+' '+t1[1])/1000:Date.parse(t11[2]+'/'+t11[1]+'/'+t11[0]+' '+t1[1])/1000;

            let t2 = e[2].split(' ');
            let t21 = t2[0].split('-');
            e[2] = (that.isZh)?Date.parse(t21[0]+'/'+t21[1]+'/'+t21[2]+' '+t2[1])/1000:Date.parse(t21[2]+'/'+t21[1]+'/'+t21[0]+' '+t2[1])/1000;
            return e;
          })
      },

      initSession1(){
        for(let i=0;i<this.Sessions[0].length;i++){
          let id1 = 'lap'+ i;
          let tr1 = document.getElementById(id1);
          tr1.style.color ="#282828";
        }
      },
      initSession2(){
        for(let i=0;i<this.Sessions[1].length;i++){
          let id1 = 'lapp'+ i;
          let tr1 = document.getElementById(id1);
          tr1.style.color ="#282828";
        }
      },
      back(){
        this.$router.push('/PatientList');
      },

    },
  }
</script>

<style scoped>
  .dateView-Container{
    height:100%;
    width:100%;
    margin:0 auto;
    font-family:SFUIText-Regular;
  }

  #sel_card_wrap{
    width:98%;
    height:520px;
    margin:40px auto;
    margin-bottom: 0px;
  }

  #pdm-card_xx {
     height:480px;
     width:265px;
    float:left;
  }

  #pdm-card {
    height:90px;
    *width:80px;
    *float:left;
    *padding:5px;
  }

  #realtime-card {
    height:90px;
    *width:775px;
    *float:left;
    margin-top:20px;
  }

  @media screen and (min-height: 950px){
    .dateView-Container{
      min-height:700px;
    }
  }
  .view-header{
    width:33%;
    margin:0 auto;
    font-family:SFUIText-Regular;
    font-size:16px;
    color:#0076ff;
    letter-spacing:-0.1px;
    text-align:center;
  }
  .view-header-left,.view-header-right{
    width: 48%;
    float: left;
    height: 30px;
    line-height: 30px;
    margin-bottom: 15px;
    cursor: pointer;
    color: #0090ff;
    border: 1px solid #0090ff;
  }
  .view-header-left{
    clear: right;
    border-top-left-radius: 7px;
    border-bottom-left-radius: 7px;
  }
  .view-header-right{
    clear: right;
    border-top-right-radius: 7px;
    border-bottom-right-radius: 7px;
  }
  .view-header-choose{
    color:#fff;
   background-color:  #0090ff;
  }
  .view-main{
    width:96%;
    margin:0 auto;
  }
  .view-main img{
    margin:165px 32%;
    width: 330px;
    height: 255px;
  }
  button{
    float: right;
    border: 1px solid #55adf8;
    outline: none;
    border-radius:100px;
    box-shadow:0 3px 4px 0 #e8f3ff;
    font-size:16px;
    height:30px;
    line-height: 30px;
    letter-spacing:-0.39px;
    text-align:center;
    margin-right:2%;
    color:#ffffff;
    background-image:linear-gradient(90deg, #42c3fd 0%, #55adf8 100%);
    margin-bottom: 20px;
    width: 150px;
    cursor: pointer;
  }

  .central-btn-container .data-delete {
    float:none;
    *margin-left:50%;
    background-image: linear-gradient(89deg, #ff3535 1%, #ff5252 100%);
    *background-image: linear-gradient(89deg, #42c3fc 1%, #55adf8 100%);
  }

  .central-btn-container {
    text-align: center;
    padding-top:20px;
    margin-top:20px;
    border-top:1px solid #dedede;
  }

  @media screen and (max-width: 1500px){
    .view-main img{
      margin:18% 32%;
      width: 330px;
      height: 255px;
    }
  }
 .view-main2{
   clear: both;
 }
  .main-header-left{
    margin-left: 1.5%;
    float: left;
    height:20px;
    line-height: 20px;
    margin-top:10px;
    margin-bottom: 15px;
    border-left: 2px solid #005dac;
  }
  .main-header-left span{
    margin-left:10px;
  }

  .table-container{
    width:100%;
    overflow-y: scroll;
    height:302px;
  }
  table{
    margin:0 auto;
    width:98%;
    color:#282828;
    font-family:SFUIText-Regular;
    border-collapse: collapse;
  }

  .header{
    height:38px;
    background-color:#cfdff0;
    font-size:15px;
    letter-spacing:-0.37px;
    width: 99%;
    clear: left;
    margin-left: 1%;
  }
  .header table{
    width:100%;
    text-align:center;
  }
  .table-title{
    height:38px;
  }
  .spe-td1{
    width:13%;
  }
  .spe-td2{
    width:11%;
  }
  .spe-td3{
    width:22%;
  }
  .spe-td4{
    width:20%;
  }
  tr{
    height: 50px;
    font-size:16px;
    letter-spacing:-0.39px;
    text-align:center;
  }
  .even{
    background:#ebeef1;
  }
  .checkbox{
    width:7%;
  }
  .pdm{
    margin-top: 20px;
  }
  table input{
    width:16px;
    height:16px;
  }
 .checkbox22{
   opacity: 0;
 }
  table label{
    display: inline-block;
    width:17px;
    height:17px;
    background: url("../../assets/checkbox.png") left 1px no-repeat;
    cursor: pointer;
  }
  .checked{
    background: url("../../assets/Select.png") left 0 no-repeat;
  }

  .daop_row {
    height:80px;
  }

  .sel-icon {
    width: 28px;
    height: 28px;
    background: url("../../assets/Unselect.png") left 0 no-repeat;
    background-size:100% 100%;
    float:left;
    margin-top:25px;
    margin-left:15px;
  }

  .sel {
    width: 28px;
    height: 28px;
    background: url("../../assets/Select2.png") left 0 no-repeat;
    background-size:100% 100%;
  }

  .daop_name {
    float:left;
    margin-left:20px;
    width:120px;
    font-size:16px;
    color:#282828;
    margin-top:29px;
  }

  .daop_text {
    float:left;
    margin-left:20px;
    font-size:16px;
    color:#282828;
    margin-top:29px;
  }

  .daop_sep {
    float:left;
    height:40px;
    width: 2px;
    border-left: solid 1px #cecece;
    margin-left:10px;
    margin-top:20px;
  }

  .daop_app_icon {
    float:left;
    width: 45px;
    height:45px;
    margin-left:10px;
    margin-top:15px;
  }

  .easytouch {
    background: url("../../assets/EasyTouch.png") left 0 no-repeat;
    background-size:100% 100%;
  }

  .easyview_ipad {
    background: url("../../assets/EasyViewiPad.png") left 0 no-repeat;
    background-size:100% 100%;
  }

  .easysense {
    background: url("../../assets/EasySense.png") left 0 no-repeat;
    background-size:100% 100%;
  }

  .easypatch {
    background: url("../../assets/EasyPatch.png") left 0 no-repeat;
    background-size:100% 100%;
  }



  #pdm-card .pdm-icon {
    *width:161px;
    *height:129px;
    width:140px;
    height:112px;
    margin:20px auto;
    margin-top:40px;
    background: url("../../assets/A6_system.png") left 0 no-repeat;
    background-size:100% 100%;
  }

  .pdm-text {
    text-align: center;
  }

  .plus-icon{
    width: 28px;
    height: 28px;
    margin:10px auto;
  }

  .pdm-app-icon {
    *width: 109px;
    *height: 107px;
    width: 95px;
    height: 93px;
    background: url("../../assets/Phone_Pad.png") left 0 no-repeat;
    background-size:100% 100%;
    margin:0 auto;
    margin-bottom: 20px;
  }

  .realtime-app-icon {
    *width: 109px;
    *height: 107px;
    width: 52px;
    height: 93px;
    background: url("../../assets/Phone.png") left 0 no-repeat;
    background-size:100% 100%;
    margin:0 auto;
    margin-bottom: 20px;
  }


  #realtime-card .pdm-icon {
    *width:161px;
    *height:129px;
    width:140px;
    height:112px;
    margin:20px auto;
    margin-top:40px;
  }

  #realtime-card .pdm-icon .icon {
    width:48px;
    height:30px;
    margin:auto;
    margin-top:25px;
    background: url("../../assets/CGM.png") left 0 no-repeat;
    background-size:100% 100%;
  }

  .card-sel {
    border: solid 2px #0087ff;
  }

  .upload_history {
    margin-top:50px;
    margin-left:20px;
  }

  .upload_history a{
    text-decoration: none;
  }



</style>



// WEBPACK FOOTER //
// dateView2.vue?03159c4f